import http from '../services/http';

import {
    ALL_VENUES_ENDPOINT,
    CREATE_VENUE_ENDPOINT,
    UPDATE_VENUE_ENDPOINT,
    DELETE_VENUE_ENDPOINT,
    generateEndpoint
} from '../services/endpoints';

export default (() => {

    const getAll = () => {

        return http.get(ALL_VENUES_ENDPOINT);
    };
    
    const create = (venueParams) => {

        return http.post(CREATE_VENUE_ENDPOINT, venueParams);
    };

    const update = (venueParams) => {

        var endpoint = generateEndpoint(UPDATE_VENUE_ENDPOINT, { id: venueParams.id });

        return http.put(endpoint, venueParams);
    };

    const remove = (venueId) => {

        var endpoint = generateEndpoint(DELETE_VENUE_ENDPOINT, { id: venueId });

        return http.delete(endpoint);
    };
    
    return {
        create,
        update,
        remove,
        getAll
    };

})();


// WEBPACK FOOTER //
// ./services/venues.js